function init( obj ) {
  var sum = 0;
  var oLength = obj.length;
  for( var el in obj ) {
    if( obj.hasOwnProperty( el ) ) {
      sum += parseFloat( obj[el] );
    }
  }
  return sum/oLength;
}
export default {
  init
}



// WEBPACK FOOTER //
// ./src/modules/calc.js